/**
 * Sdílené pomůcky pro čas z BE. BE posílá LocalDateTime bez zóny (místní čas Europe/Prague),
 * např. "2026-10-10T09:24:14". Takový řetězec se parsuje jako místní čas, proto se
 * zobrazuje přes místní (ne getUTC*) složky. Řetězec se sufixem Z / offsetem se převede do místního času.
 */

const dvou = (n: number) => String(n).padStart(2, '0');

export const parseCasBe = (iso: string | Date | null | undefined): Date | null => {
    if (!iso) return null;
    const d = iso instanceof Date ? iso : new Date(iso);
    return Number.isNaN(d.getTime()) ? null : d;
};

/** "HH:mm" v místním čase, prázdný řetězec při neplatném vstupu. */
export const formatCasHHmm = (iso: string | Date | null | undefined): string => {
    const d = parseCasBe(iso);
    return d ? `${dvou(d.getHours())}:${dvou(d.getMinutes())}` : '';
};

/** "yyyy-MM-dd" v místním čase (na rozdíl od toISOString, které dává UTC). */
export const formatDatumIso = (date: Date): string =>
    `${date.getFullYear()}-${dvou(date.getMonth() + 1)}-${dvou(date.getDate())}`;
